import { Configuration, ApiConfigOptions } from '@sg/api/base-api-lib';

export interface IdentityServerApiConfigOptions extends ApiConfigOptions {}
export class IdentityServerApiConfig extends Configuration {
  constructor(configOptions?: IdentityServerApiConfigOptions) {
    super({ ...{}, ...(configOptions || {}) });
  }
}
